import * as React from 'react';
import './noData.styles.scss';
var noData = require('../../assets/images/emptyState.png');
var NoData = React.memo(function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("img", { src: noData, className: "empty-state", alt: "no data" }),
        React.createElement("h3", { className: "empty-state-text" }, props.text)));
});
export default NoData;
//# sourceMappingURL=noData.js.map